export default __webpack_public_path__ + "static/media/brand11.35489f32.png";